<template>
  <div class="well">
    <table cellpadding="0" cellspacing="0" class="ncut-table-search"
      v-if="null != inpData">
      <tbody>
        <tr>
          <td class="ncut-edit-form-text field-title" style=" width: 11rem;">
            學校名稱：
          </td>
          <td class="ncut-base-form-ipt" colspan="2">
            <b-form-input placeholder="請輸入學校名稱" style="min-width:20rem;" :maxlength="50" tabindex="1"
              v-model="inpData.shnm[0].codeName"
              @change="inpData.shnm[0].Status='C'"/>
          </td>
        </tr>
        <tr>
          <td class="ncut-edit-form-text field-title">
            地址：
          </td>
          <td class="ncut-base-form-ipt" colspan="2">
            <b-form-input placeholder="請輸入學校地址" style="min-width:20rem;" :maxlength="50" tabindex="2"
              v-model="inpData.shAdd[0].codeName"
              @change="inpData.shAdd[0].Status='C'"/>
          </td>
        </tr>
        <tr>
          <td class="ncut-edit-form-text field-title">
            網頁抬頭：
          </td>
          <td class="ncut-base-form-ipt" colspan="2">
            <b-form-input placeholder="請輸入網頁抬頭" style="min-width:20rem;" :maxlength="50" tabindex="3"
              v-model="inpData.sysTitle[0].codeName"
              @change="inpData.sysTitle[0].Status='C'"/>
          </td>
        </tr>
        <tr>
          <td class="ncut-edit-form-text field-title">
            報表抬頭：
          </td>
          <td class="ncut-base-form-ipt" colspan="2">
            <b-form-input placeholder="請輸入報表抬頭" style="min-width:20rem;" :maxlength="50" tabindex="4"
              v-model="inpData.prnTitle[0].codeName"
              @change="inpData.prnTitle[0].Status='C'"/>
          </td>
        </tr>
        <tr>
          <td class="ncut-edit-form-text field-title">
            聯絡資訊：
          </td>
          <td class="ncut-base-form-ipt" colspan="2">
            <b-form-input placeholder="請輸入聯絡資訊" style="min-width:20rem;" :maxlength="50" tabindex="5"
              v-model="inpData.contactWindow[0].codeName"
              @change="inpData.contactWindow[0].Status='C'"/>
          </td>
        </tr>
        <tr>
          <td class="ncut-edit-form-text field-title">
            傳真：
          </td>
          <td class="ncut-base-form-ipt" colspan="2">
            <b-form-input placeholder="請輸入傳真" style="min-width:20rem;" :maxlength="50" tabindex="6"
              v-model="inpData.shFax[0].codeName"
              @change="inpData.shFax[0].Status='C'"/>
          </td>
        </tr>
        <tr>
          <td class="ncut-edit-form-text field-title">
            畫面閒置檢查時間：
          </td>
          <td class="ncut-base-form-ipt" colspan="2">
            <table>
              <tr>
                <td>
                  <b-form-input type='number' :min="0" :max="240" label="分鐘" style="width:6rem" tabindex="7"
                    v-model="inpData.idleInterval[0].codeName"
                    @change="inpData.idleInterval[0].Status='C'"/>
                </td>
                <td>
                  <span style="margin: 0 1em;">分鐘</span>
                </td>
                <td>
                  <font size="-1" color="#003399" style="vertical-align: bottom;">
                    <b>說明：</b>檢查時間最大值 <font style="font-size: larger; color:#2d0c13;">240</font> 分鐘
                  </font>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td class="ncut-edit-form-text field-title">
            自動登出顯示訊息：
          </td>
          <td class="ncut-base-form-ipt" colspan="2">
            <b-form-input placeholder="請輸入自動登出顯示訊息" style="min-width:20rem;" :maxlength="50" tabindex="8"
              v-model="inpData.idleMessage[0].codeName"
              @change="inpData.idleMessage[0].Status='C'"/>
          </td>
        </tr>
        <tr>
          <td class="ncut-edit-form-text field-title">
            系統管理員信箱：
          </td>
          <td class="ncut-base-form-ipt" colspan="2">
            <b-form-input placeholder="請輸入系統管理員信箱" style="min-width:20rem;" :maxlength="50" tabindex="9"
              v-model="inpData.receiver[0].codeName"
              @change="inpData.receiver[0].Status='C'"/>
              <font size="-1" color="#003399">
                <b>說明：</b>輸入多位收件人信箱時，以分號“；”分隔
              </font><br/>
          </td>
        </tr>
        <tr>
          <td class="ncut-edit-form-text field-title">
            伺服器網址：
          </td>
          <td class="ncut-base-form-ipt" colspan="2">
            <b-form-input placeholder="請輸入伺服器網址" style="min-width:20rem;" :maxlength="50" tabindex="10"
              v-model="inpData.serverUrl[0].codeName"
              @change="inpData.serverUrl[0].Status='C'"/>
          </td>
        </tr>
        <tr>
          <td class="ncut-edit-form-text field-title">
            系統名稱：
          </td>
          <td class="ncut-base-form-ipt" colspan="2">
            <b>是否顯示系統名稱</b>：
            <b-form-select text="請選擇是否顯示系統名稱" class="select_text" style="width: 5rem;"
              v-model="inpData.showTitle[0].codeName"
              @change="inpData.showTitle[0].Status='C'">
              <b-form-select-option key="1" :value="1">是</b-form-select-option>
              <b-form-select-option key="0" :value="0">否</b-form-select-option>
            </b-form-select>
          </td>
        </tr>
        <tr>
          <td class="ncut-edit-form-text field-title">
            選單顏色：
          </td>
          <td class="ncut-base-form-ipt" colspan="2">
            <b-button class="btn-text" variant="primary" @click="inpData.bgColor[0].codeName='primary';inpData.bgColor[0].Status='C';"
              :style="{ 'font-size': (inpData.bgColor[0].codeName=='primary'?'x-large':'initial') }">藍<font style="font-size: 40%;font-weight: 400;">（亮）</font></b-button>
            <b-button class="btn-text" variant="secondary" @click="inpData.bgColor[0].codeName='secondary';inpData.bgColor[0].Status='C';"
              :style="{ 'font-size': (inpData.bgColor[0].codeName=='secondary'?'x-large':'initial') }">灰</b-button>
            <b-button class="btn-text" variant="success" @click="inpData.bgColor[0].codeName='success';inpData.bgColor[0].Status='C';"
              :style="{ 'font-size': (inpData.bgColor[0].codeName=='success'?'x-large':'initial') }">綠</b-button>
            <b-button class="btn-text" variant="danger" @click="inpData.bgColor[0].codeName='danger';inpData.bgColor[0].Status='C';"
              :style="{ 'font-size': (inpData.bgColor[0].codeName=='danger'?'x-large':'initial') }">紅</b-button>
            <b-button class="btn-text" variant="warning" @click="inpData.bgColor[0].codeName='warning';inpData.bgColor[0].Status='C';"
              :style="{ 'font-size': (inpData.bgColor[0].codeName=='warning'?'x-large':'initial') }">黃</b-button>
            <b-button class="btn-text" variant="info"  @click="inpData.bgColor[0].codeName='info';inpData.bgColor[0].Status='C';"
              :style="{ 'font-size': (inpData.bgColor[0].codeName=='info'?'x-large':'initial') }">藍</b-button>
            <b-button class="btn-text" variant="light" @click="inpData.bgColor[0].codeName='light';inpData.bgColor[0].Status='C';"
              :style="{ 'font-size': (inpData.bgColor[0].codeName=='light'?'x-large':'initial') }">白</b-button>
            <b-button class="btn-text" variant="dark"  @click="inpData.bgColor[0].codeName='dark';inpData.bgColor[0].Status='C';"
              :style="{ 'font-size': (inpData.bgColor[0].codeName=='dark'?'x-large':'initial') }">灰</b-button>
            <!-- <el-color-picker tabindex="12"
              v-model="inpData.bgColor[0].codeName"
              @change="inpData.bgColor[0].Status='C'"
              show-alpha
              :predefine="predefineColors">
            </el-color-picker> -->
          </td>
        </tr>
        <!-- <tr>
          <td class="ncut-edit-form-text field-title">
            標題背景：
          </td>
          <td class="ncut-base-form-ipt" style="padding: 1rem 0.5rem; vertical-align: top; ">
            <b-form-file ref="file-input" class="dragdrop"
              v-model="file"
              @input="fileChange"
              :state="Boolean(file)"
              browse-text="點擊上傳"
              placeholder="選擇檔案..."
              drop-placeholder="移除檔案..."
              accept="image/jpeg, image/png, image/gif">></b-form-file>
            <p>{{ file ? file.name : '' }}</p>
          </td>
          <td class="ncut-base-form-ipt" style="padding: 2rem 0.5rem; vertical-align: top; min-width: 20rem;">
            <div slot="tip" class="el-upload__tip">
              上傳之檔案格式：
              <ul style="list-style-type:disc;">
                <li>副檔名.jpg、.png</li>
                <li>檔案含英文字母共計 60 碼為檔名。</li>
                <li>檔案大小不得超過 4MB。</li>
              </ul>
            </div>
            <b-button variant="warning"
              @click="clearImg()">清除背景圖<b-icon icon="trash"/></b-button>
          </td>
        </tr> -->
        <tr>
          <td class="ncut-base-form-text"></td>
          <td class="ncut-base-form-ipt" colspan="2"></td>
        </tr>
      </tbody>
    </table>
    <div class="ncut-base-form-button">
      <b-button variant="success" tabindex="14"
        @click="save()"><b-icon icon="check-square"/>&nbsp;{{$t('message.Save_cmd')}}</b-button>
    </div>
  </div>
</template>

<script>
import * as tools from '@/tool'
export default {
  name: 'setting',
  props: [
    'pageInfo'
  ],
  data () {
    return {
      file: undefined,
      formData: new FormData(),
      setData: [{ id: '0', name: '否' }, { id: '1', name: '是' }],
      fileList: [],
      inpData: null,
      imageUrl2: null,
      fileIdx: 0,
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ]
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    user () {
      return this.$store.state.user
    },
    setting () {
      return this.$store.getters.getSetting
    }
  },
  methods: {
    clearImg () {
      if (!tools.isNullOrWhiteSpace(this.inpData.headerFile[0].codeName)) {
        this.inpData.headerFile[0].codeName = ''
        this.inpData.headerFile[0].Status = 'C'
      }
      this.$refs['file-input'].reset()
    },
    fileChange (e) {
      var vm = this
      this.formData.append('header', this.file) // 放進上傳的檔案
      this.$http.post('./WebApi/Common/UploadV2', this.formData)
        .then((response) => {
          if (!tools.isNull(response.data)) {
            var file = response.data[0]
            vm.inpData.info2 = []
            vm.inpData.info2[0] = response.data[0]
            vm.inpData.headerFile[0].codeName = file.tempName
            vm.inpData.headerFile[0].Status = 'C'
          } else {
            tools.showAlert(vm, 'danger', '上傳檔案失敗' + error)
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error)
        })
    },
    checkSaveData () {
      for (var label in this.inpData) {
        for (var item in this.inpData[label]) {
          var obj = this.inpData[label][item]
          if (obj.Status != '') {
            return ''
          }
        }
      }
      return '無異動資料'
    },
    save () {
      const vm = this
      const msg = this.checkSaveData()
      if (msg.length === 0) {
        var data = {
          uId: this.user.id,
          sysId: this.sysId,
          data: this.inpData
        }
        this.$http.put('./WebApi/Setting/SetConfigureList', data)
          .then((response) => {
            if (response.data === true) {
              tools.showAlert(vm, 'success', '恭喜您,存檔成功')
              vm.getSettintData(true)
            } else {
              tools.showAlert(vm, 'danger', '存檔失敗')
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '網路連線失敗' + error)
          })
      } else {
        tools.showAlert(this, 'danger', '對不起,' + msg)
        return false
      }
    },
    getConfigureInfo: function (sysId) {
      return this.$http
        .get('./WebApi/Setting/GetConfigureList/'.concat(sysId))
    },
    getSettintData (flag) {
      var vm = this
      this.$http
        .get('./WebApi/Setting/GetConfigureList/'.concat(this.sysId), {
          headers: {
            Authorization: 'Bearer ' + this.token
          }
        })
        .then((response) => {
          vm.inpData = JSON.parse(response.data)
          if (flag) {
            vm.$store.dispatch('setSetting', JSON.parse(response.data))
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    }
  },
  created () {
    var vm = this
    // this.inpData = JSON.parse(JSON.stringify(this.setting))
    // console.log('== Setting ==')

    this.getSettintData(false)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.field-title {
  vertical-align: top;
  padding-top: 0.85em;
}
.btn-text {
  width: 5rem;
  border-color: gray;
  margin: 0.2rem;
}
</style>
